import React, { useState, useEffect }  from 'react';
import PickupDetails from './pick-up-details';
import ShippingDetails from './shipping-details';
import ExpressDetails from './express-details';
import './sass/below-belt.scss';
import Warning from "../../warning";
import CountDownTimer from "../../shims/countdown-timer";

function BelowBelt({
  selectedOption,
  select = () => { },
  details,
  shippingDetails,
  fulfillmentDetails,
  needMoreShown,
  handleToggle,
  showLiveGoods
}) {


  const [countDown, setCountdown] =
    useState({
      timerExpired: false,
      totalMinutes: shippingDetails.dynamicEta?shippingDetails.dynamicEta.totalMinutes:0,
      hours: shippingDetails.dynamicEta?shippingDetails.dynamicEta.hours:0,
      minutes: shippingDetails.dynamicEta?shippingDetails.dynamicEta.minutes:0
    });

  useEffect(() => {
    if(countDown.hours || countDown.minutes || countDown.totalMinutes){
      CountDownTimer.start(countDown, setCountdown);  
    }else{
      CountDownTimer.setHook(setCountdown);
    }
  }, []);

  const {
    doHideForNotifyMe,
    isNonMajorAppliance
  } = fulfillmentDetails;

  const nonMajorApplianceWarningMessage =
    <Warning>
      <span className="below-belt__non-major-appliance">This item does not qualify for the Major Appliance Delivery and Haul Away or Installation Services</span>
    </Warning>;

  const showBelowBelt =
      !fulfillmentDetails.proInstallSelected &&
      doHideForNotifyMe &&
      (!showLiveGoods || fulfillmentDetails.isBackordered) &&
      (selectedOption === "PICKUP" ||
          selectedOption === "STH" ||
          selectedOption === "EXPRESS");

  return showBelowBelt && (
    <div className="below-belt__wrapper">
      {selectedOption === "PICKUP" &&
        <PickupDetails details={details}
          handleToggle={handleToggle}
          needMoreShown={needMoreShown}
          fulfillmentDetails={fulfillmentDetails} />
      }
      {selectedOption === "STH" &&
        <ShippingDetails 
          details={details}
          countDown={countDown} />
      }
      {selectedOption === "EXPRESS" &&
        <ExpressDetails
          details={details}
          fulfillmentDetails={fulfillmentDetails}
        />
      }
      {isNonMajorAppliance && nonMajorApplianceWarningMessage}
    </div>
  );
}

export default BelowBelt;
